module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    class: [_vm.theme, this.isOpen ? '' : 'collapsed-box', _vm.isSolid ? 'box-solid' : '']
  }, [_c('div', {
    staticClass: "box-header",
    class: (_vm.isBorder || _vm.isSolid) ? 'with-border' : ''
  }, [_vm._t("icon-title"), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": _vm.widgetType
    }
  }, [_c('i', {
    class: _vm.btnIcon
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._t("content")], 2), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "box-footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), (this.isLoading) ? _c('div', {
    staticClass: "overlay"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ef947d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VABox.vue
// module id = 517
// module chunks = 1